import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { MatBadge } from '@angular/material/badge'
import { MatChip, MatChipAvatar, MatChipSet } from '@angular/material/chips'
import { ThemePalette } from '@angular/material/core'
import { MatIcon } from '@angular/material/icon'
import {
  CollectionUtil,
  ElderChipLabelDirective,
  ElderQuantityPipe,
  ElderStopEventPropagationDirective,
} from '@elderbyte/ngx-starter'
import { PackageState } from '../../../../packages/package'
import { PackageDetail, UnitBundleRef } from '../../work-item'

@Component({
  selector: 'app-work-item-packages',
  templateUrl: './work-item-packages.component.html',
  styleUrls: ['./work-item-packages.component.scss'],
  imports: [
    MatChipSet,
    MatChip,
    ElderStopEventPropagationDirective,
    MatIcon,
    MatChipAvatar,
    MatBadge,
    ElderQuantityPipe,
    ElderChipLabelDirective,
  ],
})
export class WorkItemPackagesComponent {
  // TODO WorkItemBundlesComponent?

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly detailedView = input(false)

  public readonly unitBundles = input.required<UnitBundleRef[]>()

  readonly groupedBundles = computed<WorkItemPack[]>(() => {
    if (this.unitBundles()) {
      return this.groupByPackage(this.unitBundles())
    } else {
      return []
    }
  })

  public readonly packageClick = output<WorkItemPack>()

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public trimPackageNumber(number: string): string {
    // TODO
    return number
  }

  public bundleIcon(detail: PackageDetail): string {
    if (!detail) return 'error'
    switch (detail.state) {
      case PackageState.PREDICTED:
      case PackageState.PREVIEW:
        return 'hourglass_empty'
      case PackageState.CONFIRMED:
        return 'fact_check' // fact_check
      case PackageState.DISPATCHING:
        return 'forklift' // local_shipping
      default:
        return undefined
    }
  }

  public bundleIconColor(detail: PackageDetail): ThemePalette {
    if (!detail) return 'warn'
    switch (detail.state) {
      case PackageState.PREDICTED:
      case PackageState.PREVIEW:
        return undefined
      case PackageState.CONFIRMED:
        return 'primary'
      case PackageState.DISPATCHING:
        return 'primary'
      default:
        return undefined
    }
  }

  onClick(workItemPack: WorkItemPack): void {
    this.packageClick.emit(workItemPack)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private groupByPackage(bundleRefs: UnitBundleRef[]): WorkItemPack[] {
    const groups: WorkItemPack[] = []
    CollectionUtil.groupByField(bundleRefs, 'packageId').forEach(
      (items: UnitBundleRef[], packageId: unknown) =>
        groups.push(this.buildItemPackage(<string>packageId, items, items[0]?.detail))
    )
    return groups
  }

  private buildItemPackage(
    packageId: string,
    itemBundles: UnitBundleRef[],
    detail?: PackageDetail
  ): WorkItemPack {
    return new WorkItemPack(packageId, itemBundles, detail)
  }
}

export class WorkItemPack {
  constructor(
    public packageId: string,
    public itemBundles: UnitBundleRef[],
    public detail?: PackageDetail
  ) {}

  public get packageNumber(): string {
    return this.itemBundles[0].packageNumber
  }
}
